<template>
  <li class="menu-card">
    <div class="menu-card__content" @click="opened = !opened">
      <LangRouterLink
        :to="{ name: routes(item) }"
        class="menu-card__image"
        :style="{ backgroundImage: `url('${$beet.options.menu[`${item}Img`]?.original}')` }"
        @click.native.stop="$emit('close')"
      />

      <div class="menu-card__text">
        <h5 v-if="$beet.options.menu[`${item}Title`]" class="menu-card__title">
          <LangRouterLink :to="{ name: routes(item) }" @click.native.stop="$emit('close')">{{
            $beet.options.menu[`${item}Title`]
          }}</LangRouterLink>
        </h5>

        <h5 v-else class="menu-card__title">{{ $beet.options.menu[`${item}Title`] }}</h5>
        <p>{{ $beet.options.menu[`${item}Text`] }}</p>
      </div>

      <button :class="['menu-card__caret', { '-close': opened }]" />
    </div>

    <DropDown :is-open="opened" content-tag="nav" content-class="menu-card__nav">
      <nav v-if="item === 'blog'">
        <LangRouterLink
          v-for="(post, i) in $store.getters.latest_posts"
          :key="i"
          :to="{ name: 'post.show', params: { slug: `${post.slug}-${post.id}` } }"
          class="menu-card__label"
          @click.native="$emit('close')"
        >
          <div>
            <h2>{{ post.title }}</h2>
          </div>
        </LangRouterLink>
      </nav>

      <nav v-else>
        <template v-for="hash in hashes" :key="hash">
          <LangRouterLink
            v-if="hash !== 'scholarships'"
            :to="{
              name: routes(item),
              hash: `#${$t(`navigation.anchors.${item}.${hash}`)}`,
            }"
            class="menu-card__label"
            @click.native="$emit('close')"
            >{{ $t(`navigation.labels.${item}.${hash}`) }}</LangRouterLink
          >
          <a
            v-else-if="scholarshipsLink"
            :href="scholarshipsLink"
            target="_blank"
            class="menu-card__label"
            @click.native="$emit('close')"
          >
            {{ $t(`navigation.labels.${item}.${hash}`) }}
          </a>
        </template>
      </nav>
    </DropDown>
  </li>
</template>

<script>
import DropDown from '@/components/global/DropDown.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'

export default {
  name: 'MobileNavItem',
  components: { DropDown, LangRouterLink },
  setup: () => ({ scholarshipsLink: import.meta.env.VITE_APP_SCHOLARSHIPS_PAGE_URL }),
  props: {
    item: {
      type: String,
      required: true,
    },
    hashes: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    opened: false,
  }),
  methods: {
    routes(key) {
      switch (key) {
        case 'products':
          return 'product.index'
        case 'blog':
          return 'post.index'
        default:
          return key
      }
    },
  },
}
</script>
